import axios from '@/services'

export default {
  validateUserName: async (userName) =>
    await axios.get('/api/user/username/' + userName + '/isExist'),
  validateVisaBirthday: async (visaCompanionNumber) =>
    await axios.get('/api/visa/dateOfBirth/' + visaCompanionNumber)
}
